import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class UcionicaService {

  constructor(private _http: Http) { }

  dohvatiUcionice(vrstaKorisnika: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_ucionice', vrstaKorisnika)    
    .map(res => res.json()); 
  }

  kreirajUcionicu(vrstaKorisnika: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_spremi', vrstaKorisnika)    
    .map(res => res.json()); 
  }

  urediUcionicu(vrstaKorisnika: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_uredi', vrstaKorisnika)    
    .map(res => res.json()); 
  }

  kopiraj(idUcionica: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kopiraj_ucionicu', idUcionica)    
    .map(res => res.json());
  }

  brisanjeUcionice(idUcionica: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_obrisi', idUcionica)    
    .map(res => res.json()); 
  }

  kreiranje_syllabusa(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kreiranje_syllabusa', a)
    .map(res => res.json());
  }

  dohvati_idmodule_za_ucionicu(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_idmodule_za_ucionicu', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-popis/ucionica-popis.service.ts